import { TimelineCarousel } from "@/components/ui/carousel/timeline-carousel";

const slides = [
  {
    title: "We’ll take care of everything",
    description:
      "The Birdwatch team is ready to tackle every item on your never-ending to-do list, handling projects from the smallest repair to the largest renovation, so you can finally relax knowing the work is done right.",
    image: "https://mainopt.cdn.birdwatch.com/join_1.png",
  },
  {
    title: "Your local trusted team",
    description:
      "Get a trusted, vetted team to handle your home’s upkeep. No more endless contractor calls or missed appointments; our reliable team arrives on time and ensures your projects are done with professionalism and peace of mind.",
    image: "https://mainopt.cdn.birdwatch.com/join_2.png",
  },
  {
    title: "Love your space again",
    description:
      "Reclaim your space in a snap! Birdwatch services aren't just about repairs; we're here to help you fall back in love with your home by making those aspirational upgrades you've dreamed about.",
    image: "https://mainopt.cdn.birdwatch.com/join_3.png",
  },
];

/** The sign-up marketing slider shared by the join and presale sign-up flows. */
export function SignUpSlider() {
  return <TimelineCarousel slides={slides} />;
}
